module.exports = __webpack_public_path__ + "static/blog25-03a8a1afbbbc9bb2ead80b28c840131d.png";